import { fileTypes } from '../../constants/file-types'
import { sessionStorageKeyConstants } from '../../constants/session-storage-key-constants'
import { getHeaders } from '../axios/axios-helpers'
import HttpClient from '../axios/http-client'

export async function downloadReport(fileLocation, fileName, reportType) {
  const api = `reports/download?fileName=${fileLocation}&reportType=${reportType}`
  const idToken = sessionStorage.getItem(sessionStorageKeyConstants.ID_TOKEN)
  const headers = getHeaders(idToken)
  const httpClient = new HttpClient(headers)
  try {
    const response = await httpClient.reportingInstance().get(api, { responseType: 'blob' })
    if (response.status === 200 && response?.data) {
      const blob = new Blob([response.data], { type: fileTypes.download.PDF })
      /* Create File Url */
      const fileUrl = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = fileUrl
      a.download = fileName
      a.click()
    }
  } catch {
    // Nothing to do here
  }
}
